module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showFormEdit) ? _c('div', {
    staticClass: "esocial-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close($event)
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal esocial-modal--wide"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Gerar Novo Lote")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    staticClass: "esocial-modal__body"
  }, [_c('ed-alert', {
    staticClass: "mb-3"
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n            O sistema já faz esta verificação diariamente e cria os lotes necessários. Use esse formulário só se\n            quiser forçar a geração agora, para uma empresa/layout específico.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "gerar-lote-section"
  }, [_c('div', {
    staticClass: "gerar-lote-section__title"
  }, [_vm._v("Obrigatório")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0",
    attrs: {
      "label": "Empresa",
      "placeholder": "Pesquisar empresa",
      "items": _vm.config.list.id_emp,
      "loading": _vm.config.loading.id_emp,
      "clearable": "",
      "required": ""
    },
    on: {
      "search": _vm.getEmpresa
    },
    model: {
      value: (_vm.formData.id_emp),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_emp", $$v)
      },
      expression: "formData.id_emp"
    }
  }), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0",
    attrs: {
      "label": "Layout",
      "placeholder": "Pesquisar layout",
      "items": _vm.config.list.layout,
      "loading": _vm.config.loading.layout,
      "itemText": "esocial",
      "is-object": "",
      "clearable": "",
      "required": ""
    },
    on: {
      "search": _vm.getLayout
    },
    model: {
      value: (_vm.formData.layout),
      callback: function($$v) {
        _vm.$set(_vm.formData, "layout", $$v)
      },
      expression: "formData.layout"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gerar-lote-section"
  }, [_c('button', {
    staticClass: "gerar-lote-section__toggle",
    on: {
      "click": function($event) {
        _vm.showFiltros = !_vm.showFiltros
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.showFiltros ? 'fa-chevron-up' : 'fa-chevron-down'
  }), _vm._v("\n            Filtros opcionais\n            "), (_vm.totalFiltrosAtivos) ? _c('span', {
    staticClass: "gerar-lote-section__badge"
  }, [_vm._v(_vm._s(_vm.totalFiltrosAtivos))]) : _vm._e()]), _vm._v(" "), (_vm.showFiltros) ? _c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0",
    attrs: {
      "label": "Frente de Trabalho",
      "items": _vm.config.list.id_fdt,
      "loading": _vm.config.loading.id_fdt,
      "disabled": !_vm.formData.id_emp || !_vm.formData.layout,
      "itemText": "fdt",
      "clearable": "",
      "multiple": ""
    },
    on: {
      "search": _vm.getFdt
    },
    model: {
      value: (_vm.formData.fdts),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fdts", $$v)
      },
      expression: "formData.fdts"
    }
  }), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0",
    attrs: {
      "label": "Funcionário",
      "items": _vm.config.list.id_fun,
      "loading": _vm.config.loading.id_fun,
      "disabled": !_vm.formData.id_emp || !_vm.formData.layout,
      "clearable": "",
      "multiple": ""
    },
    on: {
      "search": _vm.getFuncionario
    },
    model: {
      value: (_vm.formData.funcionarios),
      callback: function($$v) {
        _vm.$set(_vm.formData, "funcionarios", $$v)
      },
      expression: "formData.funcionarios"
    }
  }), _vm._v(" "), _c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
    attrs: {
      "label": "Data de cadastro do arquivo",
      "type": "daterange",
      "disabled": !_vm.formData.id_emp || !_vm.formData.layout
    },
    model: {
      value: (_vm.formData.created_at),
      callback: function($$v) {
        _vm.$set(_vm.formData, "created_at", $$v)
      },
      expression: "formData.created_at"
    }
  }), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0",
    attrs: {
      "label": "Não incluir os seguintes funcionários",
      "items": _vm.config.list.id_fun,
      "loading": _vm.config.loading.id_fun,
      "disabled": !_vm.formData.id_emp || !_vm.formData.layout,
      "clearable": "",
      "multiple": ""
    },
    on: {
      "search": _vm.getFuncionario
    },
    model: {
      value: (_vm.formData.funcionarios_delete),
      callback: function($$v) {
        _vm.$set(_vm.formData, "funcionarios_delete", $$v)
      },
      expression: "formData.funcionarios_delete"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0",
    attrs: {
      "label": "Somente eventos avulsos",
      "items": [{
        id: 1,
        nome: 'Sim'
      }, {
        id: 0,
        nome: 'Não'
      }],
      "disabled": !_vm.formData.id_emp || !_vm.formData.layout,
      "clearable": ""
    },
    model: {
      value: (_vm.formData.avulso),
      callback: function($$v) {
        _vm.$set(_vm.formData, "avulso", $$v)
      },
      expression: "formData.avulso"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.resultado) ? _c('div', {
    staticClass: "gerar-lote-resultado"
  }, [_c('div', {
    staticClass: "gerar-lote-resultado__icon",
    class: _vm.resultado.total_lotes ? 'is-success' : 'is-empty'
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.resultado.total_lotes ? 'fa-check-circle' : 'fa-info-circle'
  })]), _vm._v(" "), _c('div', {
    staticClass: "gerar-lote-resultado__content"
  }, [(_vm.resultado.total_lotes) ? _c('b', [_vm._v("\n              " + _vm._s(_vm.resultado.total_lotes) + " lote(s) gerado(s) com " + _vm._s(_vm.resultado.total_eventos) + " evento(s).\n            ")]) : _c('b', [_vm._v("Nenhum lote gerado.")]), _vm._v(" "), (_vm.resultado.msg) ? _c('span', [_vm._v(_vm._s(_vm.resultado.msg))]) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__footer"
  }, [_c('button', {
    staticClass: "esocial-modal__btn esocial-modal__btn--primary",
    attrs: {
      "disabled": _vm.config.loading.save
    },
    on: {
      "click": _vm.salvar
    }
  }, [(_vm.config.loading.save) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _vm._e(), _vm._v("\n          Gerar Lote\n        ")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b3d88f9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/lotes/gerar.vue
// module id = 1442
// module chunks = 45